export const ADD_TO_CART = 'ADD_TO_CART'
export const FETCH_DATA = 'FETCH_DATA'
export const DETAIL_PRODUCT = 'DETAIL_PRODUCT'
export const CLEAR_CART = 'CLEAR_CART'
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART'
export const DO_COMMANDE = 'DO_COMMANDE'
export const LAST_PRODUCT = 'LAST_PRODUCT'
export const LAST_PRODUCT2 = 'LAST_PRODUCT2'
export const LAST_PRODUCTH ='LAST_PRODUCTH'
export const lastEntriesfestina ='lastEntriesfestina'
export const LAST_PRODUCTfestina ='LAST_PRODUCTfestina'
export const lastEntriesfestinadepot ='lastEntriesfestinadepot'
export const LAST_PRODUCTfestinadepot ='LAST_PRODUCTfestinadepot'
export const lastEntriespromo='lastEntriespromo'
export const LAST_PRODUCTpromo ='LAST_PRODUCTpromo'
export const lastProductpromo ='LAST_PRODUCTpromo'

export const lastEntriesvideo ='lastEntriesvideo'
export const LAST_PRODUCTvideo ='LAST_PRODUCTvideo'
export const lastEntriesroyal ='lastEntriesroyal'
export const LAST_PRODUCTroyal ='LAST_PRODUCTroyal'
export const LAST_PRODUCTpolice ='LAST_PRODUCTpolice'
export const lastEntriesarmani = 'lastEntriesarmani'
export const lastEntriesnautica = 'lastEntriesnautica'
export const lastEntriesmaserati = 'lastEntriesmaserati'
export const lastEntriesmorellato = 'lastEntriesmorellato'
export const lastEntriestimberland ='lastEntriestimberland'
export const lastEntriesMichaelkors = 'lastEntriesMichaelkors'
export const lastEntriesconnectee ='lastEntriesconnectee'
export const lastEntriesdiesel ='lastEntriesdiesel'
export const lastEntriespolice ='lastEntriespolice'
export const lastEntriesfossil ='lastEntriesfossil'
export const lastEntrieslotus = 'lastEntrieslotus'
export const lastEntriesversus = 'lastEntriesversus'
export const lastEntriesTRUSSARDI = 'lastEntriesTRUSSARDI'
export const lastEntriesMONTIGNAC ='lastEntriesMONTIGNAC'
export const LAST_PRODUCTarmani = 'LAST_PRODUCTarmani'
export const LAST_PRODUCTnautica = 'LAST_PRODUCTnautica'
export const LAST_PRODUCTmaserati = 'LAST_PRODUCTmaserati'
export const LAST_PRODUCTmorellato = 'LAST_PRODUCTmorellato'
export const LAST_PRODUCTtimberland ='LAST_PRODUCTtimberland'
export const LAST_PRODUCTMichaelkors = 'LAST_PRODUCTMichaelkors'
export const LAST_PRODUCTconnectee ='LAST_PRODUCTconnectee'
export const LAST_PRODUCTdiesel ='LAST_PRODUCTdiesel'
export const LAST_PRODUCTfossil ='LAST_PRODUCTfossil'
export const LAST_PRODUCTcerruti ='LAST_PRODUCTcerruti'
export const LAST_PRODUCTlotus = 'LAST_PRODUCTlotus'
export const LAST_PRODUCTversus = 'LAST_PRODUCTversus'
export const LAST_PRODUCTTRUSSARDI = 'LAST_PRODUCTTRUSSARDI'
export const LAST_PRODUCTMONTIGNAC ='LAST_PRODUCTMONTIGNAC'
export const lastEntriesref ='lastEntriesref'
export const LAST_PRODUCTref ='LAST_PRODUCTref'
export const LAST_PRODUCTreference ='LAST_PRODUCTreference'

export const USER_INFO ='USER_INFO'
export const user ='user'
export const LOGIN = 'LOGIN'
export const REGISTER = 'REGISTER'
export const LOAD_CART = 'LOAD_CART'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js